const Countdown = require('countdown-js');

const interviewTimer = () => {

    const FIVE_MINUTES = 5 * 60 * 1000;
    const NOW = new Date().getTime();

    const counter = $('#countdown');
    const startTime = new Date(counter.data('time'));
    const interviewLink = counter.data('interview-link');
    const activeBefore = counter.data('active-before');
    const webinarFinished = $('[data-webinar-finished]');

    timer(startTime);

    function timer(end) {

        Countdown.timer(end, function (timeLeft) {
            let hours = timeLeft.days * 24 + timeLeft.hours;

            $('.js-hours').html(hours);
            $('.js-minutes').html(timeLeft.minutes);
            $('.js-seconds').html(timeLeft.seconds);

            if (hours === 0 && timeLeft.minutes < activeBefore) {
                activeButton();
            }

        }, function () {
            if (end.getTime() + FIVE_MINUTES > NOW) {
                activeButton();
            } else {
                webinarFinished.text(webinarFinished.data('webinar-finished')).addClass('text-danger');
            }
        })

    }

    function activeButton() {
        $('.js-login-button').removeClass('disabled').attr('href', interviewLink);
    }
};

export default interviewTimer;
